import { observable, action } from 'mobx';
import Alert from 'react-s-alert';
import i18next from 'i18next';

import { App } from 'core';

import { FormStore } from 'libs/forms/app';
import { clientStore } from 'apps/client/app';
import { modalStore } from 'apps/modals/app';

import { conf } from 'apps/signIn/config.yaml';
import { clearInviteLink } from 'apps/utils';

export class SignInApp extends App {
  static registryName = 'SignInApp';
  @observable usernameEmail = '';
  @observable password = '';
  @observable signOut = false;
  init() {
    this.form = new FormStore(this, conf, 'signInForm');
  }

  @action SignIn = () => {
    if (this.form.isValid) {
      this.form.SetPosting(true);
      clientStore.SetPosting(true);
      this.manager.SignIn({
        onSysErr: this.onSysError,
        onUserErr: this.onUserErr,
        onSuccess: this.onSuccess.bind(this),
      });
    } else {
      this.form.alert();
    }
  };

  @action onSysError = error => {
    this.form.SetPosting(false);
    clientStore.SetPosting(false);

    if (error?.message?.includes('Email not confirmed')) {
      clientStore.routerStore.router.navigate('onboarding.checkEmail');
      return;
    }

    Alert.error(
      i18next.t('Hmm... We failed to sign you in. Please try again.'),
    );
  };

  @action onUserErr = () => {
    this.form.SetPosting(false);
    clientStore.SetPosting(false);
    this.password = '';
  };

  @action submitSuccessAction = () => {
    clientStore.SetPosting(false);
    this.form.SetPosting(false);
    this.form.clearDraft();
  };

  @action handleSignIn = () => {
    const { routerStore } = clientStore;
    modalStore.Close();

    clearInviteLink();

    clientStore.WhoAmI();

    const nextParams = routerStore.params.get('next');
    if (nextParams !== undefined) {
      const next = routerStore.router.matchPath(nextParams);

      if (!next) {
        window.location.href = nextParams;
        return;
      }

      clientStore.routerStore.navigate(next.name, next.params, {
        replace: true,
      });
    }

    this.usernameEmail = '';
    this.password = '';
  };

  async onSuccess(result) {
    if (result.result !== 'ok') {
      Alert.error(
        i18next.t('Incorrect Username / Email or Password. Please try again.'),
      );
      clientStore.SetPosting(false);
      this.form.SetPosting(false);
      return;
    }

    this.submitSuccessAction();

    if (result.profile.profileConfirmed) {
      this.handleSignIn();
    } else {
      clientStore.routerStore.navigate('onboarding.confirmProfile');
    }
  }
}
